import { MultiLanguageValue } from "@shared/types"

export const getTranslatedLabel = (value: MultiLanguageValue | undefined | null): string => {
  const i18n = window.__I18N__

  // Accessing global stores directly since this is a helper function and not a composable
  const userStore = window.__HOST_STORES__?.userStore
  const globalStore = window.__HOST_STORES__?.globalStore

  if (value == undefined || value == null || value.languages == null || value.languages.length === 0) {
    return ""
  }

  const currentLocale = userStore?.user?.language || i18n.locale.value
  const languageEntry = value.languages.find((lang) => lang.languageCode === currentLocale)

  if (languageEntry && languageEntry.value) {
    return languageEntry.value
  }

  const baseLanguage = globalStore?.configurations?.baseLanguage || "en-US"
  const baseLanguageEntry = value.languages.find((lang) => lang.languageCode === baseLanguage)
  if (baseLanguageEntry && baseLanguageEntry.value) {
    return baseLanguageEntry.value
  }

  return ""
}

export const getTranslatedList = (
  listToTranslate: any[] | undefined,
  fields: (string | { key: string; fields?: string[]; transform?: (value: any) => string })[],
) => {
  if (!listToTranslate || listToTranslate.length === 0) return []
  if (!fields || fields.length === 0) return []

  return listToTranslate.map((item) => {
    const translatedList: any = { ...item }
    fields.forEach((field) => {
      // Handle custom transformer object
      if (typeof field === "object" && field.key && field.transform) {
        const propName = `translated${String(field.key).charAt(0).toUpperCase() + String(field.key).slice(1)}`
        translatedList[propName] = field.transform(item[field.key])
        return
      }

      // Handle multi-field object
      if (typeof field === "object" && field.key && field.fields && Array.isArray(field.fields)) {
        field.fields.forEach((subField) => {
          const multiLangValue = item[field.key] ? (item[field.key][subField] as MultiLanguageValue) : null
          if (multiLangValue) {
            const propName = `translated${String(field.key).charAt(0).toUpperCase() + String(field.key).slice(1)}${
              String(subField).charAt(0).toUpperCase() + String(subField).slice(1)
            }`
            translatedList[propName] = getTranslatedLabel(multiLangValue)
          }
        })
        return
      }

      // Handle simple string field
      if (typeof field === "string") {
        if (field !== undefined && field !== null && (item[field] as MultiLanguageValue)) {
          const propName = `translated${String(field).charAt(0).toUpperCase() + String(field).slice(1)}`
          translatedList[propName] = getTranslatedLabel(item[field] as MultiLanguageValue)
        }
      }
    })
    return translatedList
  })
}

export const isExternalRoute = (route: string): boolean =>
  route.startsWith("{legacyJptUrl}/") || route.startsWith("http://") || route.startsWith("https://")
